<div class="courses">
  <div
    class="cards-container"
    role="list"
    [ngClass]="{
      'snake-layout': currentLayoutView === 'SnakeView',
      'grid-layout': currentLayoutView === 'CardView',
      'list-layout': currentLayoutView === 'ListView' || currentLayoutView === 'NumberedListView',
    }"
  >
    @for (card of cards; track card._id + '_' + $index; let i = $index) {
      <ptl-card-item
        role="listitem"
        class="card-item"
        [card]="card"
        [cardIndex]="i"
        [viewType]="currentLayoutView"
        [reservedRows]="reservedRows"
        (cardClick)="onCardClick($event)"
      ></ptl-card-item>
    }
  </div>
</div>
